import { PropertyValue } from '@givebacks/api/backer';
import { AdditionalInformationForm, SaveChangesButton } from 'core/Components';
import { Modal, Stack, Text } from 'ui';

type SharedInfoProps = { properties: PropertyValue[]; causeId: string };

const SharedInfo = ({ properties, causeId }: SharedInfoProps) => {
  return (
    <Stack gap="lg" mb={-16}>
      <Stack gap={4}>
        <Text fz={18} fw={600}>
          Shared Information
        </Text>
        <Text fz={12} fw={400} c="gray.6">
          This is information that you&apos;re sharing with your organization.
        </Text>
      </Stack>
      <AdditionalInformationForm properties={properties} />
      <Modal.AffixedFooter>
        <SaveChangesButton causeId={causeId} />
      </Modal.AffixedFooter>
    </Stack>
  );
};

export { SharedInfo };
